import { ItemBlock } from './Row';
import { extractMergedRow } from './extractMergedRow';
import { MergedGroup } from './Subrow';

export function buildMergedGroups(blocks: ItemBlock[]): MergedGroup[] {
  const maxRowIndex = Math.max(...blocks.map(block => block.items.length));
  const rowIndexes = Array.from({ length: maxRowIndex }, (_, k) => k);

  return rowIndexes.reduce((acc, rowIndex) => {
    const { mergedRow } = extractMergedRow(blocks, rowIndex);
    if (mergedRow) {
      // new merged group
      return [
        ...acc,
        {
          mergedRow,
          unmergedBlocks: [],
        },
      ];
    }

    if (acc.length === 0) {
      // no group yet
      return [
        {
          mergedRow: undefined,
          unmergedBlocks: blocks.map(block => ({
            items: block.items.slice(rowIndex, rowIndex + 1),
          })),
        },
      ];
    }

    // add row to blocks items of the latest merged group
    return acc.map((group, idx) => {
      if (idx === acc.length - 1) {
        const updatedUnmergedBlocks = blocks.map((block, blockIdx) => ({
          items: (group.unmergedBlocks[blockIdx]?.items || []).concat(
            block.items.slice(rowIndex, rowIndex + 1),
          ),
        }));
        return {
          ...group,
          unmergedBlocks: updatedUnmergedBlocks,
        };
      }

      return group;
    });
  }, [] as MergedGroup[]);
}
